/* eslint-disable */

import { Component } from "react";

type OwnProps = {
  active?: $TSFixMe; // NOSONAR
  translationKey?: string; // NOSONAR
  className?: string; // NOSONAR
  children: React.ReactNode; // NOSONAR
};

const defaultProps: Partial<OwnProps> = {
  className: "",
};

type Props = OwnProps & typeof defaultProps;

class NavigationDropdownItem extends Component<Props> {
  static componentName = "NavigationDropdownItem";

  static readonly defaultProps = defaultProps;
}

export default NavigationDropdownItem;
